import { useEffect, useState } from "react";
import SntSearch from "@/components/ReactBootstrap/SntSearch";
import { AdvanceFilter } from "@cleanup/components/AdvancedFilters/FilterStyle";

interface FilterTypeSettings {
  searchFieldPlaceholder?: string;
}

interface Descriptor {
  _idx: string;
  key: string;
  label: string;
  description: string;
  filterType: string;
  filterTypeSettings?: FilterTypeSettings;
}

interface FilterValue {
  searchText: string;
}

interface FilterData {
  filterValue?: FilterValue;
}

interface MultiStringFilterProps {
  descriptor: Descriptor;
  data?: FilterData;
  onChange?: (data: FilterData | { idx: string; data: null }) => void;
  disabled?: boolean;
}

const MultiStringFilter: React.FC<MultiStringFilterProps> = ({
  descriptor,
  data = {},
  onChange,
  disabled = false,
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchFieldPlaceholder] = useState(
    (descriptor.filterTypeSettings &&
      descriptor.filterTypeSettings.searchFieldPlaceholder) ||
      ""
  );
  const [description] = useState((descriptor && descriptor.description) || "");

  useEffect(() => {
    setSearchText(
      (data && data.filterValue && data.filterValue.searchText) || ""
    );
  }, [data, data.filterValue]);

  const getData = (text: string = searchText): FilterData | { idx: string; data: null } => {
    if (text === "" || text === undefined) {
      return {
        idx: descriptor._idx,
        data: null,
      };
    }
    const newData = JSON.parse(JSON.stringify(data)) as FilterData;
    newData.filterValue = {
      searchText: text || "",
    };

    return newData;
  };

  const onChangeInput = (text: string) => {
    setSearchText(text);
    if (onChange) {
      onChange(getData(text));
    }
  };

  return (
    <AdvanceFilter>
      <SntSearch
        value={searchText}
        placeholder={searchFieldPlaceholder}
        title={description}
        disabled={disabled}
        onChange={onChangeInput}
      />
    </AdvanceFilter>
  );
};

export default MultiStringFilter;
